module.exports = __webpack_public_path__ + "img/icon-reflash-green.4a2304f9.png";